<template>
    <v-alert
        v-if="actualAppliedHidings.length !== 0"
        type="warning"
        colored-border
        border="left"
        dense
    >
        <div
            v-for="hiding in actualAppliedHidings"
            :key="hiding.id"
        >
            <div v-if="hiding.is_description_visible" class="explanation-hiding-description">
                {{ hiding.hideString }} disembunyikan

                <template v-if="hiding.open_at">
                    sementara sampai
                    {{ parseFromServer(hiding.open_at).formatShortDayAndTime() }}
                </template>

                <template v-fi="hiding.reason">
                    karena
                    {{ hiding.reason }}
                </template>
            </div>
        </div>
    </v-alert>
</template>

<script>
import moment, { parseFromServer }  from '@/plugins/moment'

export default {
    props: {
        appliedHidings: {
            type: Array,
            required: true
        },
    },

    computed: {
        actualAppliedHidings() {
            return this.appliedHidings
                .filter(hiding => ! hiding.open_at || parseFromServer(hiding.open_at) > moment())
                .map(hiding => {
                    if (! hiding.is_description_visible) {
                        return hiding
                    }

                    const result = hiding
                    const hideString = []

                    if (hiding.is_answer_hidden) {
                        hideString.push('kunci jawaban')
                    }

                    if (hiding.is_explanation_image_hidden) {
                        hideString.push('pembahasan')
                    }

                    if (hiding.is_explanation_video_hidden) {
                        hideString.push('pembahasan video')
                    }

                    switch (hideString.length) {
                        case 1:
                            result.hideString = hideString[0]
                            break
                        case 2:
                            result.hideString = hideString.join(' dan ')
                            break
                        default:
                            hideString[hideString.length - 1] = `dan ${hideString[hideString.length - 1]}`

                            result.hideString = hideString.join(', ')
                    }

                    return result
                })
        }
    },

    methods: {
        parseFromServer
    }
}
</script>

<style lang="css">
    .explanation-hiding-description:first-letter {
        text-transform: uppercase;
    }
</style>
